export { default as Tag } from './Tag'
export { default as TagDouble } from './TagDouble'
export { TagVariant, TagStyle } from './types'
export type { TagComponentType } from './types'
